export default class AppointmentList {
  #ui;
  #pagination;
  #timezone;
  #selectedDate;
  #defaultDate;

  get eventTarget() {
    return this.#ui.list;
  }

  get selectedDate() {
    return this.#selectedDate;
  }

  constructor() {
    this.#pagination = {
      history: [],
      currentStart: "",
      nextStart: "",
    };
  }

  init(timezone) {
    this.#timezone = timezone;
    this.#cacheUiElements();
    this.#initDatePicker();
    this.#bindEvents();
  }

  show({
    lastPage, start, end, appointments
  }) {
    this.#ui.list.empty();

    if (appointments.length === 0) {
      const $row = $("<div class=\"appointment py-2\">Sorry, there are no appointments available after the selected date.</div>");
      this.#ui.list.append($row);
    } else {
      $.each(appointments, (i, appointment) => {
        const startTime = moment.tz(appointment.start, this.#timezone);
        const $row = $(`<div class="appointment row border-bottom py-2"><div class="col-sm-4 px-0">${startTime.format("ddd DD/MM/YYYY")}</div><div class="col-sm-3 px-0">${startTime.format("h:mm a")}</div><div class="col-sm-5 px-0">${appointment.provider.fullName}</div></div>`);
        $row.attr("data-id", appointment.id);

        this.#ui.list.append($row);

        $row.click(() => {
          const $allRows = this.#ui.list.find(".appointment");
          $allRows.removeClass("active");
          $row.addClass("active");

          this.eventTarget.triggerHandler("select.appointment-list", appointment);
        });
      });

      this.#updatePagination(lastPage, start, end);
    }

    this.#ui.wrap.removeClass("hidden");
    this.#ui.wrap.fadeIn();
    window.scroller.scrollToElemTop(this.#ui.wrap);
  }

  previousPage() {
    const previousStart = this.#pagination.history.pop();
    this.eventTarget.triggerHandler("change.appointment-list", previousStart);
  }

  nextPage() {
    this.#pagination.history.push(this.#pagination.currentStart);
    this.eventTarget.triggerHandler("change.appointment-list", this.#pagination.nextStart);
  }

  clear() {
    this.#ui.wrap.fadeOut();
    this.#ui.backButton.fadeOut();
    this.#ui.nextButton.fadeOut();
    this.#ui.list.empty();

    this.#selectedDate = this.#ui.datePicker.datetimepicker("date");
    this.#pagination.history = [];
  }

  remove(appointmentId) {
    const $row = this.#ui.list.find(`[data-id='${appointmentId}']`);
    $row.remove();
  }

  #cacheUiElements() {
    this.#ui = {
      datePicker: $("#earliest-date-picker"),
      wrap: $("#select-appointment-wrap"),
      list: $(".appointments"),
      backButton: $("#select-appointment-wrap .btn.back"),
      nextButton: $("#select-appointment-wrap .btn.next"),
    };
  }

  #initDatePicker() {
    this.#ui.datePicker.datetimepicker({
      format: "DD/MM/YYYY", // This is the DISPLAY format
      defaultDate: this.#ui.datePicker.data("default-date"),
      minDate: this.#ui.datePicker.data("min-date"),
      maxDate: this.#ui.datePicker.data("max-date"),
    });

    this.#selectedDate = this.#ui.datePicker.datetimepicker("viewDate");
  }

  #bindEvents() {
    this.#ui.backButton.click(() => {
      this.previousPage();
    });

    this.#ui.nextButton.click(() => {
      this.nextPage();
    });

    this.#ui.datePicker.on("change.datetimepicker", (e) => {
      // Update the appointment list

      this.#updateDate(e.date);
    });
  }

  #updateDate(newDate) {
    this.clear();
    this.#selectedDate = newDate;

    // The datetime picker creates moment objects in the local timezone of the device,
    // so we need to reinterpret this in the practice timezone before sending it elsewhere.
    // If we pass the moment object, conversion occurs (bad), so we pass a string instead.
    const selectedDate = moment.tz(this.#selectedDate.format("YYYY-MM-DD"), this.#timezone);
    this.eventTarget.triggerHandler("change.appointment-list", selectedDate);
  }

  #updatePagination(lastPage, start, end) {
    this.#pagination.currentStart = moment.tz(start, this.#timezone).toDate();
    // Next page begins after this page's last appointment
    this.#pagination.nextStart = moment.tz(end, this.#timezone).toDate();

    if (this.#isFirstPage()) {
      this.#ui.backButton.fadeOut();
    } else {
      this.#ui.backButton.fadeIn();
    }

    if (lastPage) {
      this.#ui.nextButton.fadeOut();
    } else {
      this.#ui.nextButton.fadeIn();
    }
  }

  #isFirstPage() {
    return this.#selectedDate.isSame(this.#ui.datePicker.datetimepicker("viewDate"), "day")
      && this.#pagination.history.length === 0;
  }
}
